<div *ngIf="config" class="form-group row">
  <div
  *ngIf="config.selectionMode === tableSelectionMode.Multiple && config.showSelectionBanner"
  class="col-12"
>
  <div class="select-all-card" *ngIf="selectedItems?.length > 0">
    <span
      class="select-all-card-text"
      [innerHTML]="selectedAll
        ? ('Table.AllItemsAreSelectedAcrossAllPages' | i18next: { value: config.totalRecords })
        : ('Table.SelectedOutOfItems' | i18next: { selectedItemsLength: selectedItems.length, totalRecords: config.totalRecords })"
    ></span>
    <button class="btn btn-link select-all-card-btn" (click)="clearSelection()">
      {{ 'Table.ClearSelection' | i18next }}
    </button>
    <button
      class="btn btn-link select-all-card-btn"
      *ngIf="!selectedAll && !config.lazyLoading"
      (click)="toggleSelectAll()"
      [innerHTML]="'Table.SelectAllItemsAcrossAllPages' | i18next: { value: config.totalRecords }"
    ></button>
  </div>
</div>
  <div *ngIf="config.showHeader" class="col-12">
    <!-- Table header and action bar -->
    <hb-action-header [headerText]="config.title" headerType="subtitle">
      <hb-small-action-button
        button
        [buttonId]="config.id + '-add-button'"
        *ngIf="config.enableAdd"
        title="{{ 'Table.Add' | i18next: { value: config.itemTypeName } }}"
        [icon]="'plus-circle'"
        [largeIcon]="true"
        (clickEvent)="addClicked.emit()"
        [disabled]="config.canAdd"
      >
      </hb-small-action-button>
      <hb-small-action-button
        button
        [buttonId]="config.id + '-filter-button'"
        buttonClasses="filter-toggle-btn"
        *ngIf="config.enableFiltering"
        title="{{ 'Table.ToggleFilters' | i18next }}"
        [icon]="'filter'"
        [largeIcon]="true"
        (clickEvent)="toggleFilters()"
        [isToggleButton]="true"
        [disabled]="!config.enableHeader"
        [toggleState]="config.showFilters"
      >
      </hb-small-action-button>
      <hb-small-action-button
        button
        *ngFor="let action of config.actions"
        [buttonId]="action.actionId + '-action-button'"
        title="{{ action.title }}"
        icon="{{ action.icon }}"
        [largeIcon]="true"
        [disabled]="!action.enable"
        [style.display]="action.visible ? 'block' : 'none'"
        (clickEvent)="onTableAction.emit(action)"
      >
      </hb-small-action-button>
    </hb-action-header>
  </div>
  <div class="col-md-12">
    <div class="data-display-table">
      <p-table
        #table
        [value]="data"
        [selectionMode]="config.selectionMode"
        [(selection)]="selectedItems"
        [scrollable]="config.enableScrolling"
        [selectionPageOnly]="config.selectionPageOnly"
        [sortField]="config.startingSortField"
        [sortOrder]="config.startingSortOrder"
        [customSort]="config.useSortTransformation"
        (sortFunction)="customSort($event)"
        [paginator]="config.enablePagination"
        [rows]="config.rowsPerPage"
        [columns]="config.columns"
        [frozenColumns]="config.fixedColumns"
        [frozenWidth]="config.fixedColumnWidth"
        [resizableColumns]="config.enableColumnResize"
        columnResizeMode="expand"
        [editMode]="config.editMode"
        [dataKey]="config.dataKey"
        [lazy]="config.lazyLoading"
        [lazyLoadOnInit]="config.lazyLoadOnInit"
        (onLazyLoad)="loadLazy.emit($event)"
        [totalRecords]="config && config.lazyLoading ? config.totalRecords : data ? data.length : 0"
        [loading]="config.loading"
        [filters]="config.filters"
        [(first)]="config.first"
        (onRowSelect)="onRowSelect.emit($event)"
        (onFilter)="onFilter.emit($event)"
        (onRowUnselect)="onRowUnselect.emit($event)"
        (selectionChange)="selectionChanged($event)"
        [rowsPerPageOptions]="config.rowsPerPageOptions"
        (onRowReorder)="onRowReorder.emit($event)"
        (onPage)="onPage($event)"
        paginatorDropdownAppendTo="body"
        emptyMessage="config.emptyMessage"
      >
        <ng-template pTemplate="colgroup">
          <colgroup *ngIf="!config.showFixedColumns">
            <col *ngIf="config.reorderableRow" class="reorderable-column" />
            <col *ngIf="config.enableSelectionColumn" class="selection-column" />
            <col *ngIf="config.rowHighlightFunction && config.showRowHighlightInfoColumn" class="highlight-column" />
            <col *ngIf="config.enableEdit && config.editMode != editMode.Cell" class="icon-column-editing" />
            <col *ngIf="config.showRowIndexColumn" class="row-index-column" />
            <col *ngFor="let col of config.columns" [ngStyle]="{ 'width.px': col.widthPx, 'min-width.px': col.minWidthPx }" />
            <col *ngIf="config.enableDelete" class="icon-column" />
          </colgroup>
          <colgroup *ngIf="config.showFixedColumns">
            <col *ngIf="config.reorderableRow" class="reorderable-column hbtable-reorder" />
            <col *ngIf="config.enableDelete" class="icon-column hbtable-delete" />
            <col *ngIf="config.enableEdit && config.editMode != editMode.Cell" class="icon-column-editing hbtable-edit" />
            <col *ngIf="config.enableSelectionColumn" class="selection-column hbtable-select" />
            <col *ngIf="config.rowHighlightFunction && config.showRowHighlightInfoColumn" class="highlight-column hbtable-highlight" />
            <col *ngIf="config.showRowIndexColumn" class="row-index-column" />
            <col *ngFor="let col of config.columns" [ngStyle]="{ 'width.px': col.widthPx, 'min-width.px': col.minWidthPx }" />
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr [ngClass]="{ 'disabled-header': !config.enableHeader }" class="header-row" *ngIf="!config.showFixedColumns">
            <!-- Reorderable Column Header -->
            <th id="reorderable-column" *ngIf="config.reorderableRow"></th>
            <!-- Selection Header -->
            <th id="selection-column" *ngIf="config.enableSelectionColumn">
              <p-tableHeaderCheckbox *ngIf="config.showSelectionBanner"></p-tableHeaderCheckbox>
            </th>
            <!-- Highlight Header -->
            <th id="highlight-column" *ngIf="config.rowHighlightFunction && config.showRowHighlightInfoColumn"></th>
            <!-- Edit headers -->
            <th id="edit-column" *ngIf="config.enableEdit && config.editMode != editMode.Cell"></th>
            <!-- Row Index Column Header -->
            <th id="row-index-column" *ngIf="config.showRowIndexColumn" class="text-center">#</th>
            <!-- Dynamic column headers -->
            <th
              scope="col"
              *ngFor="let col of columns"
              class="cell-output"
              [pSortableColumn]="col.inputType === inputType.Dropdown ? col.labelField : col.valueField"
              [pSortableColumnDisabled]="!config.enableSorting || !col.sortable"
              [pTooltip]="col.additionalInfo ? col.header + ' - ' + col.additionalInfo : col.header"
              [showDelay]="config.tooltipDelay"
              pResizableColumn
            >
              {{ col.header }}
              <i *ngIf="col.additionalInfo" id="additional-info-icon" class="fa fa-info-circle"></i>
              <p-sortIcon
                *ngIf="config.enableSorting && col.sortable"
                [field]="col.inputType === inputType.Dropdown ? col.labelField : col.valueField"
                ariaLabel="{{ 'Table.Sort' | i18next }}"
                ariaLabelDesc="{{ 'Table.SortDescending' | i18next }}"
                ariaLabelAsc="{{ 'Table.SortAscending' | i18next }}"
              >
              </p-sortIcon>
            </th>
            <!-- Delete header -->
            <th id="delete-column" *ngIf="config.enableDelete"></th>
          </tr>
          <tr [ngClass]="{ 'disabled-header': !config.enableHeader }" class="header-row" *ngIf="config.showFixedColumns">
            <!-- Reorderable Column Header -->
            <th id="reorderable-column" *ngIf="config.reorderableRow" class="hbtable-reorder"></th>
            <!-- Delete header -->
            <th id="delete-column" *ngIf="config.enableDelete" class="hbtable-delete"></th>
            <!-- Edit headers -->
            <th id="edit-column" *ngIf="config.enableEdit && config.editMode != editMode.Cell" class="hbtable-edit"></th>
            <!-- Selection Header -->
            <th id="selection-column" *ngIf="config.enableSelectionColumn" class="hbtable-select">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <!-- Highlight Header -->
            <th id="highlight-column" *ngIf="config.rowHighlightFunction && config.showRowHighlightInfoColumn" class="hbtable-highlight"></th>
            <!-- Row Index Column Header -->
            <th id="row-index-column" *ngIf="config.showRowIndexColumn" class="text-center">#</th>
            <!-- Dynamic column headers -->
            <th
              scope="col"
              *ngFor="let col of columns"
              class="cell-output"
              [pSortableColumn]="col.inputType === inputType.Dropdown ? col.labelField : col.valueField"
              [pSortableColumnDisabled]="!config.enableSorting || !col.sortable"
              [pTooltip]="col.additionalInfo ? col.header + ' - ' + col.additionalInfo : col.header"
              [showDelay]="config.tooltipDelay"
              pResizableColumn
            >
              {{ col.header }}
              <i *ngIf="col.additionalInfo" id="additional-info-icon" class="fa fa-info-circle"></i>
              <p-sortIcon
                *ngIf="config.enableSorting && col.sortable"
                [field]="col.inputType === inputType.Dropdown ? col.labelField : col.valueField"
                ariaLabel="{{ 'Table.Sort' | i18next }}"
                ariaLabelDesc="{{ 'Table.SortDescending' | i18next }}"
                ariaLabelAsc="{{ 'Table.SortAscending' | i18next }}"
              >
              </p-sortIcon>
            </th>
          </tr>
          <!-- Filter row -->
          <tr [ngClass]="{ 'disabled-header': !config.enableHeader }" *ngIf="config.enableFiltering && config.showFilters" class="filter-row">
            <th scope="col" *ngIf="config.reorderableRow"></th>
            <th scope="col" *ngIf="!config.showFixedColumns && config.enableSelectionColumn"></th>
            <th scope="col" *ngIf="!config.showFixedColumns && config.rowHighlightFunction && config.showRowHighlightInfoColumn"></th>
            <th scope="col" *ngIf="!config.showFixedColumns && config.enableEdit && config.editMode != editMode.Cell"></th>
            <th scope="col" *ngIf="config.showRowIndexColumn"></th>
            <th scope="col" *ngFor="let col of columns; let idx = index" [attr.data-index]="idx">
              <div *ngIf="!col.hideFilter">
                <hb-datepicker-control
                  *ngIf="col.formatterPipe?.name === 'DateTimeFormatterLabelPipe' || col.formatterPipe?.name === 'DateTimeFormatterPipe'"
                  [controlId]="config.id + '-filter-input-' + col.valueField + '-' + idx | cellEditorControlIdPipe"
                  [inputClass]="'w-100 ui-inputtext ui-widget ui-corner-all'"
                  placeholderText=""
                  (onDateChange)="setupHeaderFilters($event, col)"
                ></hb-datepicker-control>
                <input
                  *ngIf="col.formatterPipe?.name !== 'DateTimeFormatterLabelPipe' && col.formatterPipe?.name !== 'DateTimeFormatterPipe'"
                  [id]="config.id + '-filter-input-' + col.valueField"
                  pInputText
                  type="text"
                  class="w-100 ui-inputtext ui-corner-all"
                  (input)="setupHeaderFilters($event.target.value, col)"
                  [value]="
                    config.filters[col.inputType === inputType.Dropdown ? col.labelField : col.valueField]
                      ? config.filters[col.inputType === inputType.Dropdown ? col.labelField : col.valueField].value
                      : ''
                  "
                />
              </div>
            </th>
            <th scope="col" *ngIf="config.enableDelete"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-editing="editing" let-rowIndex="rowIndex">
          <ng-template [ngTemplateOutlet]="config.groupRowTemplateRef" [ngTemplateOutletContext]="{ rowData: rowData, rowIndex: rowIndex }">
          </ng-template>
          <tr
            [pEditableRow]="rowData"
            [pSelectableRow]="!config.enableSelectionColumn ? rowData : null"
            [pSelectableRowDisabled]="!config.selectionMode || config.enableSelectionColumn"
            [pSelectableRowIndex]="!config.enableSelectionColumn ? rowIndex : null"
            [ngClass]="rowNgClass(rowData)"
            [pReorderableRow]="rowIndex"
          >
            <!-- Reorderable cell -->
            <td *ngIf="config.reorderableRow" class="hbtable-reorder">
              <i class="fa fa-bars" pReorderableRowHandle></i>
            </td>
            <!-- Delete button (Fixed columns) -->
            <td *ngIf="config.showFixedColumns && config.enableDelete" class="text-center hbtable-delete">
              <a
                [id]="config.id + '-delete-button-' + rowIndex"
                *ngIf="rowData | dynamicPipe: config.hideDeletePipe:[]:rowData"
                class="delete-btn"
                (click)="deleteClicked.emit(rowData)"
                title="{{ 'Table.Delete' | i18next: { value: config.itemTypeName } }}"
              >
                <i class="fa fa-trash pointer"></i>
              </a>
            </td>
            <!-- Edit buttons (Fixed columns) -->
            <td
              *ngIf="config.showFixedColumns && config.enableEdit && config.editMode != editMode.Cell"
              class="text-center hbtable-edit"
              frozen="true"
            >
              <a
                [id]="config.id + '-edit-button-' + rowIndex"
                *ngIf="!editing || config.rowEditMode === rowEditMode.Dialog"
                (click)="editRow(rowData)"
                title="{{ 'Table.Edit' | i18next: { value: config.itemTypeName } }}"
                pInitEditableRow
              >
                <i class="fa fa-pencil-square pointer"></i>
              </a>
              <a
                [id]="config.id + '-edit-confirm-button-' + rowIndex"
                *ngIf="editing && config.rowEditMode !== rowEditMode.Dialog"
                class="edit-confirm"
                (click)="editConfirm(rowData)"
                title="{{ 'Table.Save' | i18next }}"
                pSaveEditableRow
              >
                <i class="fa fa-check pointer"></i>
              </a>
              <a
                [id]="config.id + '-edit-cancel-button-' + rowIndex"
                *ngIf="editing && config.rowEditMode !== rowEditMode.Dialog"
                class="edit-cancel"
                (click)="editCancel(rowData)"
                title="{{ 'Table.Cancel' | i18next }}"
                pCancelEditableRow
              >
                <i class="fa fa-times pointer"></i>
              </a>
            </td>
            <!-- Selection cell -->
            <td *ngIf="config.enableSelectionColumn" class="text-center">
              <p-tableCheckbox [value]="rowData" *ngIf="!(config.disableRowByProp && rowData[config.disableRowByPropValue])"></p-tableCheckbox>
            </td>
            <!-- Highlight cell -->
            <td *ngIf="config.rowHighlightFunction && config.showRowHighlightInfoColumn" class="highlightColumn">
              <div class="highlightCell">
                <span *ngFor="let highlightMessage of rowData.highlightMessages">
                  <i [class]="'fa fa-' + highlightMessage.icon" [pTooltip]="highlightMessage.message"></i>
                </span>
              </div>
            </td>

            <!-- Edit buttons (non-fixed columns) -->
            <td *ngIf="!config.showFixedColumns && config.enableEdit && config.editMode != editMode.Cell" class="text-center" frozen="true">
              <a
                [id]="config.id + '-edit-button-' + rowIndex"
                *ngIf="(!editing || config.rowEditMode === rowEditMode.Dialog) && (rowData | dynamicPipe: config.hideEditPipe:[]:rowData)"
                (click)="editRow(rowData)"
                title="{{ 'Table.Edit' | i18next: { value: config.itemTypeName } }}"
                [ngClass]="{ isDisabled: config.editEnabledPipe && rowData | dynamicPipe: config.editEnabledPipe:[]:rowData }"
                pInitEditableRow
              >
                <i class="fa fa-pencil-square pointer"></i>
              </a>
              <a
                [id]="config.id + '-edit-confirm-button-' + rowIndex"
                *ngIf="editing && config.rowEditMode !== rowEditMode.Dialog"
                class="edit-confirm"
                (click)="editConfirm(rowData)"
                title="{{ 'Table.Save' | i18next }}"
                pSaveEditableRow
              >
                <i class="fa fa-check pointer"></i>
              </a>
              <a
                [id]="config.id + '-edit-cancel-button-' + rowIndex"
                *ngIf="editing && config.rowEditMode !== rowEditMode.Dialog"
                class="edit-cancel"
                (click)="editCancel(rowData)"
                title="{{ 'Table.CancelButton' | i18next }}"
                pCancelEditableRow
              >
                <i class="fa fa-times pointer"></i>
              </a>
            </td>

            <!-- Row Index Column Header -->
            <td *ngIf="config.showRowIndexColumn" class="text-center">{{rowIndex+1}}</td>

            <!-- Dynamic columns -->
            <td *ngFor="let col of columns; let i = index" pEditableColumn #cell>
              <div
                class="cell-output"
                *ngIf="!config.enableEdit || !col.editable || (config.editMode === editMode.Row && config.rowEditMode === rowEditMode.Dialog)"
                [pTooltip]="rowData | cellData: col | dynamicPipe: col.formatterPipe:col.formatterPipeArgs:rowData"
                [tooltipPosition]="i === columns?.length - 1 ? 'left' : 'right'"
                [tooltipDisabled]="col.outputType === outputType.Custom"
                [tooltipZIndex]="1070"
                [showDelay]="config.tooltipDelay"
              >
                <div [ngSwitch]="col.outputType">
                  <div *ngSwitchCase="outputType.Link">
                    <a
                      *ngIf="
                        !col.linkDisabledField ||
                          !(rowData[col.linkDisabledField] | dynamicPipe: col.linkDisabledPipe:col.linkDisabledPipeArgs:rowData);
                        else disabledLink
                      "
                      [id]="config.id + '-cell-link-' + col.valueField + '-' + rowIndex"
                      class="output-link"
                      target="_blank"
                      (click)="col.linkClickEvent(rowData)"
                    >
                      {{ rowData | cellData: col | dynamicPipe: col.formatterPipe:col.formatterPipeArgs:rowData }}
                    </a>
                    <ng-template #disabledLink>
                      {{ rowData | cellData: col | dynamicPipe: col.formatterPipe:col.formatterPipeArgs:rowData }}
                    </ng-template>
                  </div>
                  <div *ngSwitchCase="outputType.Checkbox">
                    <p-checkbox
                      *ngIf="!(col.hideColumnData && rowData[col.hideColumnDataByRowValue])"
                      [binary]="true"
                      [disabled]="!col.hideColumnData"
                      [ngModel]="rowData | cellData: col"
                      (onChange)="dataChanged(rowData)"
                    ></p-checkbox>
                  </div>
                  <div *ngSwitchCase="outputType.MultilineText">
                    <div *ngFor="let currentText of rowData | cellData: col">
                      {{ currentText }}
                    </div>
                  </div>
                  <div *ngSwitchCase="outputType.DropdownLabel">
                    {{ (col.options | findSelectedOption: (rowData | cellData: col:true))?.label }}
                  </div>
                  <div *ngSwitchCase="outputType.Custom">
                    <ng-template
                      [ngTemplateOutlet]="col.customOutputTemplateRef"
                      [ngTemplateOutletContext]="{
                        cellData: rowData | cellData: col | dynamicPipe: col.formatterPipe:col.formatterPipeArgs:rowData,
                        rowData: rowData
                      }"
                    ></ng-template>
                  </div>
                  <div *ngSwitchDefault>{{ rowData | cellData: col | dynamicPipe: col.formatterPipe:col.formatterPipeArgs:rowData }}</div>
                </div>
              </div>
              <p-cellEditor
                *ngIf="config.enableEdit && col.editable && (config.editMode !== editMode.Row ? true : config.rowEditMode === rowEditMode.Cell)"
              >
                <ng-template pTemplate="input" *ngIf="col.editable">
                  <div [ngSwitch]="col.inputType">
                    <div *ngSwitchCase="inputType.Dropdown">
                      <p-dropdown
                        [id]="config.id + '-cell-dropdown-' + col.valueField + '-' + rowIndex"
                        appendTo="body"
                        [options]="col.options"
                        [ngModel]="rowData | cellData: col:true"
                        (ngModelChange)="modelChanged(rowData, col, $event)"
                        styleClass="w-100"
                        (onChange)="col.dropdownChangedEvent ? col.dropdownChangedEvent($event, rowIndex, rowData) : null"
                        (onFocus)="col.dropdownFocusEvent ? col.dropdownFocusEvent(rowIndex, col, rowData) : null"
                      >
                      </p-dropdown>
                    </div>
                    <div *ngSwitchCase="inputType.MultiDropdown">
                      <p-multiSelect
                        [id]="config.id + '-cell-multidropdown-' + col.valueField + '-' + rowIndex"
                        styleClass="hb-multi-select w-100"
                        appendTo="body"
                        [filter]="true"
                        defaultLabel="{{ col.placeholder }}"
                        virtualScroll="true"
                        itemSize="30"
                        maxSelectedLabels="10"
                        [options]="col.options"
                        [ngModel]="rowData | cellData: col:true"
                        (onChange)="onChangeMultiSelect($event, col, rowIndex, rowData)"
                        panelStyleClass="hb-multiselect-panel"
                        (onPanelShow)="onMultiSelectPanelShow()"
                        (onPanelHide)="onMultiSelectPanelHide()"
                      ></p-multiSelect>
                    </div>
                    <div *ngSwitchCase="inputType.Text">
                      <input
                        [id]="config.id + '-cell-input-' + col.valueField + '-' + rowIndex"
                        pInputText
                        type="text"
                        [ngModel]="rowData | cellData: col"
                        (ngModelChange)="modelChanged(rowData, col, $event)"
                        class="w-100 ui-inputtext ui-corner-all"
                      />
                    </div>
                    <div>
                      <input
                        [id]="config.id + '-cell-number-input-' + col.valueField + '-' + rowIndex"
                        *ngSwitchCase="inputType.Number"
                        pInputText
                        type="number"
                        [ngModel]="rowData | cellData: col"
                        (ngModelChange)="modelChanged(rowData, col, $event)"
                        class="w-100 ui-inputtext ui-corner-all"
                      />
                    </div>
                    <div *ngSwitchCase="inputType.Checkbox" class="d-flex flex-row justify-content-between">
                      <p-checkbox [binary]="true" [ngModel]="rowData | cellData: col" (ngModelChange)="modelChanged(rowData, col, $event)"></p-checkbox>
                      <div class="align-self-center">
                        <i class="fa fa-edit" pTooltip="{{ 'Table.ClickToEdit' | i18next }}"></i>
                      </div>
                    </div>
                    <div *ngSwitchCase="inputType.DateTime">
                      <hb-datepicker-control
                        [controlId]="config.id + '-filter-input-' + col.valueField + '-' + rowIndex | cellEditorControlIdPipe"
                        [inputClass]="'w-100 ui-inputtext ui-widget ui-corner-all'"
                        [ngModel]="rowData | cellData: col"
                        (ngModelChange)="modelChanged(rowData, col, $event)"
                      ></hb-datepicker-control>
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="d-flex flex-row justify-content-between">
                    <div
                      class="cell-output"
                      [pTooltip]="rowData | cellData: col | dynamicPipe: col.formatterPipe:col.formatterPipeArgs:rowData"
                      [showDelay]="config.tooltipDelay"
                    >
                      <div [ngSwitch]="col.outputType">
                        <div *ngSwitchCase="outputType.Link">
                          <a
                            *ngIf="
                              !col.linkDisabledField ||
                                !(rowData[col.linkDisabledField] | dynamicPipe: col.linkDisabledPipe:col.linkDisabledPipeArgs:rowData);
                              else disabledLink
                            "
                            [id]="config.id + '-cell-link-' + col.valueField + '-' + rowIndex"
                            class="output-link"
                            target="_blank"
                            (click)="col.linkClickEvent(rowData)"
                          >
                            {{ rowData | cellData: col | dynamicPipe: col.formatterPipe:col.formatterPipeArgs:rowData }}
                          </a>
                          <ng-template #disabledLink>
                            {{ rowData | cellData: col | dynamicPipe: col.formatterPipe:col.formatterPipeArgs:rowData }}
                          </ng-template>
                        </div>
                        <div *ngSwitchCase="outputType.Checkbox">
                          <p-checkbox
                            [binary]="true"
                            [ngModel]="rowData | cellData: col"
                            (ngModelChange)="modelChanged(rowData, col, $event)"
                          ></p-checkbox>
                        </div>
                        <div *ngSwitchCase="outputType.MultilineText">
                          <div *ngFor="let currentText of rowData | cellData: col" class="cell-output">
                            {{ currentText }}
                          </div>
                        </div>
                        <div *ngSwitchCase="outputType.DropdownLabel">
                          {{ (col.options | findSelectedOption: (rowData | cellData: col:true))?.label }}
                        </div>
                        <div *ngSwitchDefault class="cell-output">
                          {{ rowData | cellData: col | dynamicPipe: col.formatterPipe:col.formatterPipeArgs:rowData }}
                        </div>
                      </div>
                    </div>
                    <div *ngIf="col.editable" class="align-self-center">
                      <i class="fa fa-edit" pTooltip="{{ 'Table.ClickToEdit' | i18next }}"></i>
                    </div>
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>
            <!-- Delete button (non-fixed) -->
            <td *ngIf="!config.showFixedColumns && config.enableDelete" class="text-center">
              <a
                [id]="config.id + '-delete-button-' + rowIndex"
                *ngIf="rowData | dynamicPipe: config.hideDeletePipe:[]:rowData"
                class="delete-btn"
                (click)="deleteClicked.emit(rowData)"
                title="{{ 'Table.Delete' | i18next: { value: config.itemTypeName } }}"
              >
                <i class="fa fa-trash pointer"></i>
              </a>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [colSpan]="config | colSpan" class="ui-table-tbody-emptymessage">
              {{ 'Table.NoItemsFound' | i18next: { value: config.itemTypeName.toLowerCase() } }}
              <a
                [id]="config.id + '-empty-message-link'"
                *ngIf="config.allowAddEmptyMessage"
                class="output-link"
                target="_blank"
                (click)="addClicked.emit()"
              >
                {{ 'Table.CreateNew' | i18next: { value: config.itemTypeName.toLowerCase() || ('Table.New' | i18next) } }}
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
